import React, { ReactNode } from 'react';

import { Button, MenuProps } from 'antd';
import { Layout, Menu, theme } from 'antd';
import { Iconsvg } from '../../../icon/icon';
import useAuth from '../../../hooks/useAuth';
import { Link, useLocation } from 'react-router-dom';
import icomlogin from '../../../img/login-icon.png';

const { Content, Sider } = Layout;
interface Children {
  children: ReactNode;
}
type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group'
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const items: MenuItem[] = [
  getItem(
    <div>
      รหัสคูปอง <Link to={'/'} />
    </div>,
    '1'
  ),

  getItem(
    <div style={{ borderBottom: '1px solid #C6C6C6' }}></div>,
    'grp',
    null,
    [],
    'group'
  ),
  getItem(
    <div>
      รายการรีวอร์ด <Link to={'reward/list'} />
    </div>,
    '2'
  ),
  getItem(
    <div style={{ borderBottom: '1px solid #C6C6C6' }}></div>,
    'grp',
    null,
    [],
    'group'
  ),
];
export const SiderComponent = (props: Children) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { logout, user } = useAuth();
  console.log('user', user);
  const { pathname } = useLocation();

  return (
    <Layout
      style={{ minHeight: '100vh', background: 'none', padding: '58px 40px' }}
    >
      <Sider className="sider-navbar">
        <div style={{ textAlign: 'center' }}>
          <img src={icomlogin} alt="login" width="100px" height="150px" />
        </div>
        <Menu
          defaultSelectedKeys={['1']}
          mode="inline"
          selectedKeys={pathname !== '/reward/list' ? ['1'] : ['2']}
          className="item-sider"
          items={items}
          style={{ textAlign: 'center' }}
        />
        <div
          style={{
            height: '100%',
            alignItems: 'end',
            justifyContent: 'center',
            display: 'flex',
            gap: '10px',
          }}
        >
          <Button
            className="button-logout"
            icon={<Iconsvg.IconLogOut />}
            onClick={logout}
          >
            ออกจากระบบ
          </Button>
          {/* <Iconsvg.IconLogOut></Iconsvg.IconLogOut> <div>ออกจากระบบ</div> */}
        </div>
      </Sider>
      <Layout
        className="site-layout-set"
        style={{ backgroundColor: 'transparent' }}
      >
        {/* <Header style={{ padding: 0, background: colorBgContainer }} /> */}
        <Content style={{ padding: '0px 20px' }}>
          <div>
            <div
              style={{
                color: '#FFFFFF',
                fontWeight: 600,
                fontSize: '24px',
                lineHeight: '22px',
                padding: '20px 50px',
              }}
            >
              Hello. {user?.name}
            </div>
            <div
              style={{
                padding: 24,
                background: colorBgContainer,
                borderRadius: '35px',
                height: '80vh',
              }}
            >
              {props.children}
            </div>
          </div>
        </Content>
        {/* <Footer style={{ textAlign: 'center' }}>
      Ant Design ©2018 Created by Ant UED
    </Footer> */}
      </Layout>
    </Layout>
  );
};
export const SiderComponentMobile = (props: Children) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { logout, user } = useAuth();
  console.log('user', user);
  const { pathname } = useLocation();

  return (
    <Layout style={{ background: 'none' }}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        className="sider-navbar-mobile"
        style={{ zIndex: '1', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)' }}
      >
        <div style={{ textAlign: 'center' }}>
          <img src={icomlogin} alt="login" width="100px" height="150px" />
        </div>
        <Menu
          defaultSelectedKeys={['1']}
          selectedKeys={pathname !== '/reward/list' ? ['1'] : ['2']}
          mode="inline"
          className="item-sider"
          items={items}
          style={{ textAlign: 'center', padding: '20px 20px' }}
        />
        <div
          style={{
            alignItems: 'end',
            justifyContent: 'center',
            display: 'flex',
            gap: '10px',
            height: window.innerHeight <= 700 ? '50%' : '60%',
          }}
        >
          <Button
            className="button-logout"
            icon={<Iconsvg.IconLogOut />}
            onClick={logout}
          >
            ออกจากระบบ
          </Button>
          {/* <Iconsvg.IconLogOut></Iconsvg.IconLogOut> <div>ออกจากระบบ</div> */}
        </div>
      </Sider>
      <Layout
        className="site-layout-set"
        style={{ backgroundColor: 'transparent' }}
      >
        {/* <Header style={{ padding: 0, background: colorBgContainer }} /> */}
        <Content style={{ margin: '0 16px' }}>
          <div
            style={{
              color: '#FFFFFF',
              fontWeight: 600,
              fontSize: window.innerWidth <= 425 ? '22px' : '24px',
              lineHeight: '22px',
              padding: '40px 30px 20px 30px',
            }}
          >
            Hello. {user?.name}
          </div>
          <div
            style={{
              padding: 24,
              background: colorBgContainer,
              borderRadius: '35px',
              height: window.innerWidth <= 768 ? '82vh' : '80vh',
            }}
          >
            {props.children}
          </div>
        </Content>
        {/* <Footer style={{ textAlign: 'center' }}>
      Ant Design ©2018 Created by Ant UED
    </Footer> */}
      </Layout>
    </Layout>
  );
};
